import * as yup from 'yup';

export const fullSchema = yup.object().shape(
  {
    singleCuUnits: yup.number().when(['singleDpUnits', 'fullDuUnits'], {
      is: (singleDpUnits: number | string, fullDuUnits: number | string) => !singleDpUnits && !fullDuUnits,
      then: yup.number().required(),
    }),
    singleDpUnits: yup.number().when(['singleCuUnits', 'fullDuUnits'], {
      is: (singleCuUnits: number | string, fullDuUnits: number | string) => !singleCuUnits && !fullDuUnits,
      then: yup.number().required(),
    }),
    fullDuUnits: yup.number().when(['singleCuUnits', 'singleDpUnits'], {
      is: (singleCuUnits: number | string, singleDpUnits: number | string) => !singleCuUnits && !singleDpUnits,
      then: yup.number().required(),
    }),
    accountedPrice: yup.number().positive().nullable(true),
    accountedValue: yup.number(),
    expirationDate: yup.date(),
    productionDate: yup.date(),

    lot: yup.string(),

    chamberNumber: yup.number().integer().required(),
    column: yup.number().integer().required(),
    letter: yup.string().required(),
    level: yup.number().integer().required(),

    manufacturerId: yup.string().required(),
    supplierId: yup.string().required(),
    supplierDocument: yup.string(),
    supplierDocumentDate: yup.date(),
    sellOrderId: yup.string(),
    purchaseOrderId: yup.string().required(),
    warehouseId: yup.string().required(),
    warehouseOwnerId: yup.string().required(),

    movementType: yup.string().required(),
    status: yup.string().required(),
    condition: yup.string().required(),
  },
  [
    ['singleCuUnits', 'singleDpUnits'],
    ['singleCuUnits', 'fullDuUnits'],
    ['singleDpUnits', 'fullDuUnits'],
  ],
);

export const statusSchema = yup.object().shape(
  {
    singleCuUnits: yup.number().when(['singleDpUnits', 'fullDuUnits'], {
      is: (singleDpUnits: number | string, fullDuUnits: number | string) => !singleDpUnits && !fullDuUnits,
      then: yup.number().required(),
    }),
    singleDpUnits: yup.number().when(['singleCuUnits', 'fullDuUnits'], {
      is: (singleCuUnits: number | string, fullDuUnits: number | string) => !singleCuUnits && !fullDuUnits,
      then: yup.number().required(),
    }),
    fullDuUnits: yup.number().when(['singleCuUnits', 'singleDpUnits'], {
      is: (singleCuUnits: number | string, singleDpUnits: number | string) => !singleCuUnits && !singleDpUnits,
      then: yup.number().required(),
    }),
    chamberNumber: yup.string().required(),
    column: yup.string().required(),
    letter: yup.string().required(),
    level: yup.string().required(),
  },
  [
    ['singleCuUnits', 'singleDpUnits'],
    ['singleCuUnits', 'fullDuUnits'],
    ['singleDpUnits', 'fullDuUnits'],
  ],
);

export const removeSchema = yup.object().shape(
  {
    singleCuUnits: yup.number().when(['singleDpUnits', 'fullDuUnits'], {
      is: (singleDpUnits: number | string, fullDuUnits: number | string) => !singleDpUnits && !fullDuUnits,
      then: yup.number().required(),
    }),
    singleDpUnits: yup.number().when(['singleCuUnits', 'fullDuUnits'], {
      is: (singleCuUnits: number | string, fullDuUnits: number | string) => !singleCuUnits && !fullDuUnits,
      then: yup.number().required(),
    }),
    fullDuUnits: yup.number().when(['singleCuUnits', 'singleDpUnits'], {
      is: (singleCuUnits: number | string, singleDpUnits: number | string) => !singleCuUnits && !singleDpUnits,
      then: yup.number().required(),
    }),
  },
  [
    ['singleCuUnits', 'singleDpUnits'],
    ['singleCuUnits', 'fullDuUnits'],
    ['singleDpUnits', 'fullDuUnits'],
  ],
);

export const locationSchema = yup.object().shape({
  chamberNumber: yup.string().required(),
  column: yup.string().required(),
  letter: yup.number().required(),
  level: yup.string().required(),
});
